import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import { TopSwitcher } from '../../components/top-switcher';
import { ByOffersSerach } from '../../components/by-offers-search';
import { ByParamsSearch } from '../../components/by-params-search';
import { useStore } from 'effector-react';
import { $activeSearchTab, setActiveSearchTab } from '../../store/search.store';
import { getLastCachedSearchResultValue } from '@/modules/common/helpers/cache-search-result.helper';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ByRangesSearch } from '../../components/by-ranges-search';

export const SearchPage = () => {
  const navigate = useNavigate();
  const cachedSearch = getLastCachedSearchResultValue();

  const activeTab = useStore($activeSearchTab);

  useEffect(() => {
    if (cachedSearch) return navigate(cachedSearch);
  }, []);
  return (
    <PageTemplate
      header="поиск"
      className={styles.rootParent}
      mainClassName={styles.mainParent}
    >
      <div className={styles.root}>
        <TopSwitcher activeTab={activeTab} setActiveTab={setActiveSearchTab} />
        <div className={styles.contentArea}>
          {activeTab === 0 ? <ByOffersSerach /> : activeTab === 1 ? <ByParamsSearch /> : <ByRangesSearch/>}
        </div>
      </div>
    </PageTemplate>
  );
};
